let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bnUV1")).then(() => parcelRequire('ceVmw'));